export default __webpack_public_path__ + "static/media/pupainting-homesmall.be00667d.jpg";